import React, { useContext, useState } from 'react'
import { TokenBalance } from '../../../../../../graphql/generated/graphql'

export enum SubscriptionStep {
    Configure,
    Confirm,
    Create,
    Summary,
}

type CreateSubscriptionContext =
    | {
          container: HTMLDivElement | null
          setContainer: React.Dispatch<React.SetStateAction<HTMLDivElement | null>>
          token: TokenBalance
          step: SubscriptionStep
          setStep: React.Dispatch<React.SetStateAction<SubscriptionStep>>
      }
    | undefined

const CreateSubscriptionState = React.createContext<CreateSubscriptionContext>(undefined)

export const useCreateSubscription = () => {
    const context = useContext(CreateSubscriptionState)
    if (!context)
        throw new Error(
            'Cannot use useManageSubscription outside of a <CreateSubscriptionProvider />'
        )
    return context
}

export const CreateSubscriptionProvider: React.FC<{ token: TokenBalance }> = ({
    children,
    token,
}) => {
    const [step, setStep] = useState<SubscriptionStep>(SubscriptionStep.Configure)
    const [container, setContainer] = useState<HTMLDivElement | null>(null)

    return (
        <CreateSubscriptionState.Provider value={{ container, setContainer, token, step, setStep }}>
            {children}
        </CreateSubscriptionState.Provider>
    )
}
